import { render, staticRenderFns } from "./ProductSaleProgramList.vue?vue&type=template&id=1c4fb0b6&scoped=true&"
import script from "./ProductSaleProgramList.vue?vue&type=script&lang=js&"
export * from "./ProductSaleProgramList.vue?vue&type=script&lang=js&"
import style0 from "./ProductSaleProgramList.vue?vue&type=style&index=0&id=1c4fb0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4fb0b6",
  null
  
)

export default component.exports